<template>
    <div>
        <TaskInformation :task-id="taskId" />

        <GeneralInformation :task-id="taskId" />

        <RequestView :task-id="taskId" />

        <InquiryRequestView :task-id="taskId" />

        <StrategicSatisfactionRequestView :task-id="taskId" />

        <OperationalIndicatorRequestView :task-id="taskId" />

        <AdditionalAnalysisRequestView :task-id="taskId" />

        <ScientificConsultationRequestView :task-id="taskId" />

        <FocusGroupsRequestView :task-id="taskId" />

        <TaskRibbon :task-id="taskId"
                    :complete="taskBits.canComplete"
                    :redirect="taskBits.canRedirect"
                    :rework="taskBits.canRework"
                    :close="taskBits.canClose"
                    :require-comment="isFinalStep"
                    @complete="onComplete"
                    @succeed="succeeded"
                    @rework="onRework" />
    </div>
</template>
<script>
    import TasksService from '@/services/TasksService.js'
    import { ActivityDefinitionsEnum } from '@/helpers/constants/enumerations.js'

    import TaskInformation from '@/components/app/task/TaskInformation.vue'
  
    import GeneralInformation from '@/components/app/task/dynamic/GeneralInformation.vue'
    import TaskRibbon from '@/components/app/task/TaskRibbon.vue'
    import RequestView from '@/components/app/task/RequestView.vue'
    import InquiryRequestView from '@/components/app/task/InquiryRequestView.vue'
    import StrategicSatisfactionRequestView from '@/components/app/task/StrategicSatisfactionRequestView.vue'
    import OperationalIndicatorRequestView from '@/components/app/task/OperationalIndicatorRequestView.vue'
    import AdditionalAnalysisRequestView from '@/components/app/task/AdditionalAnalysisRequestView.vue'
    import ScientificConsultationRequestView from '@/components/app/task/ScientificConsultationRequestView.vue'
    import FocusGroupsRequestView from '@/components/app/task/FocusGroupsRequestView.vue'



    export default {

        components: {
            TaskInformation,
            GeneralInformation,
            TaskRibbon,
            RequestView,
            InquiryRequestView,
            StrategicSatisfactionRequestView,
            OperationalIndicatorRequestView,
            AdditionalAnalysisRequestView,
            ScientificConsultationRequestView,
            FocusGroupsRequestView,
        },

        props: {
            taskId: {
                type: Number,
                default: null
            }
        },

        data() {
            return {
                workProgramsDialog: false,
                taskBits: {
                    activityDefinitionName: null,
                    canRedirect: false,
                    canRework: false,
                    canClose: false,
                    canComplete: false,
                }
            }
        },

        computed: {
            isReviewComments() {
                return ActivityDefinitionsEnum.addComments === this.taskBits.activityDefinitionName
            },

            // final step of the request workflows ("Publish") requires a mandatory completion comment
            isFinalStep() {
                return this.taskBits.activityDefinitionName === 'Publish'
            },

        },

        created() {
            this.getTaskBits()
        },

        methods: {

            getTaskBits() {

                TasksService.getTaskBits(this.taskId).then(res => {
                    if (res.data != null) {
                        this.taskBits = res.data
                    }
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                })
            },


            onComplete(proceedCallBackMethod) {
                proceedCallBackMethod(null)
            },

            onRework(proceedCallBackMethod) {
                proceedCallBackMethod(null)
            },

            succeeded(success) {
                this.$emit('completed', success)
            }
        }
    }
</script>